import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import invariant from "tiny-invariant";
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Modal,
  Paper,
  useTheme,
  Typography,
  TextField,
} from "@mui/material";
import { TreeContext } from "../tree-context";
import useStyles from "./styles";
import { TreeItem } from "../../data/tree";
import api from "../../../../../services/api";
import { useNotification } from "../../../../notificationProvider";

type FormData = {
  parent: string;
  position: number;
};

export function RenameModal({
  onClose,
  itemId,
  item,
  open,
}: {
  onClose: () => void;
  itemId: string;
  open: boolean;
  item: TreeItem;
}) {
  const { dispatch, getChildrenOfItem, getMoveTargets, getPathToItem } =
    useContext(TreeContext);
  const theme = useTheme();
  const styles = useStyles(theme);
  const [newTitle, setNewTitle] = useState(item.title || "");
  const [newPath, setNewPath] = useState(item.path || "");
  const options = useMemo(() => {
    const targets = getMoveTargets({ itemId });
    const targetOptions = targets.map((item) => ({
      label: `Item ${item.title}`,
      value: item.id,
    }));
    return [{ label: "Sem página pai", value: "" }, ...targetOptions];
  }, [getMoveTargets, itemId]);

  const [loading, setLoading] = useState(false);
  const notify = useNotification();

  useEffect(() => {
    setNewTitle(item.title || "");
  }, [item.title]);
  async function handlePostEditNameApi(
    id: string,
    title: string,
    path: string
  ): Promise<any | null | undefined> {
    try {
      setLoading(true);
      const response = await api.put("/pages/update", {
        id,
        title,
        path,
      });
      if (response.status === 200) {
        notify(null, "Editado com sucesso", "success");
        return response.data;
      }
    } catch (error: any) {
      if (error.code && !error.response) {
        notify(error.code, error.message, "error");
      } else {
        notify(error.status, error?.response?.data.message, "error");
      }
    } finally {
      setLoading(false);
    }
    return null;
  }

  const onSubmit = useCallback(
    async (event: React.FormEvent) => {
      event.preventDefault();
      // console.log("onSubmit", parentId, newTitle);
      const data = await handlePostEditNameApi(itemId, newTitle, newPath);
      if (!data) {
        // notify(null, "Erro ao editar", "error");
        return;
      }
      if (item.title) {
        dispatch({
          type: "rename",
          itemId,
          newTitle: data.title, // Assuming item.title is the new title
          newPath: data.path,
          // targetId: parentId,
          // index: position - 1,
        });
        onClose();
      }
    },
    [dispatch, itemId, onClose, newTitle, item.title]
  );
  function slugify(text: string): string {
    return (
      "/" +
      text
        .trim()
        .toLowerCase()
        .replace(/ç/g, "c")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
    );
  }
  useEffect(() => {
    setNewPath(slugify(newTitle));
  }, [newTitle]);
  return (
    <Modal open={open} closeAfterTransition onClose={onClose} sx={styles.modal}>
      <Paper sx={styles.paper}>
        <form onSubmit={onSubmit}>
          <Box sx={styles.boxHeader}>
            <Typography variant="h6">
              Renomar<i> "{item.title}"</i>
            </Typography>
          </Box>
          <Box sx={styles.boxContent}>
            {/* <Box display="flex" flexDirection="column" gap={2} mt={1}> */}
            <TextField
              label="Digite o novo nome"
              variant="filled"
              fullWidth
              disabled={loading}
              value={newTitle} // Assuming itemId is the name to be changed
              onChange={(e) => {
                setNewTitle(e.target.value);
              }}
            />{" "}
            {item.type === "FILHO" && (
              <TextField
                label="Path"
                variant="filled"
                name="path"
                disabled={true}
                // required
                autoFocus
                value={newPath}
                // onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                //   setPath(slugify(e.target.value))
                // }
                // sx={styles.textField}
              />
            )}
            {/* </Box> */}
          </Box>
          <Box sx={styles.boxActions}>
            <Button onClick={onClose} variant="outlined">
              Cancelar
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Salvar
            </Button>
          </Box>
        </form>
      </Paper>
    </Modal>
  );
}
